module.exports = __webpack_public_path__ + "static/media/chartjsLogo.ed2f373e.svg";